import { useEffect as d } from "react";
function i({ isOpen: e, onClose: n, closeOnEsc: t }) {
  const o = (r) => {
    r.key === "Escape" && t && n();
  };
  d(() => (e && document.addEventListener("keydown", o), () => {
    document.removeEventListener("keydown", o);
  }), [e, t, n]);
}
export {
  i as useInlineDrawerKeydown
};
